<template>
  <nuxt-link
    v-if="footerLink.type === 'nuxt'"
    :to="footerLink.data.url"
    :data-testid="`footer-link-${footerLink.key}`"
    class="capitalize text-mouse hover:text-white no-underline block w-full py-1 md:inline md:w-auto md:py-0"
  >
    {{ translateLabel(footerLink) }}
  </nuxt-link>
  <span
    v-else-if="footerLink.type === 'native'"
    class="capitalize text-mouse hover:text-white cursor-pointer block w-full py-1 md:inline md:w-auto md:py-0"
    @click="footerLink.data.onclick"
  >
    {{ translateLabel(footerLink) }}
  </span>
  <a
    v-else
    :href="footerLink.data.url"
    :data-testid="`footer-link-${footerLink.key}`"
    class="capitalize text-mouse hover:text-white no-underline block w-full py-1 md:inline md:w-auto md:py-0"
    :target="footerLink.type === 'external' ? '_blank' : null"
    :rel="footerLink.type === 'external' ? 'noopener' : null"
  >
    {{ translateLabel(footerLink) }}
  </a>
</template>

<script lang="ts">
import { useLabelTranslation } from '../navigation/sidebar/features/utils';
import type { FooterLink } from './types';

export default defineComponent({
  props: {
    footerLink: {
      type: Object as PropType<FooterLink>,
      required: true,
    },
  },
  setup() {
    const translateLabel = useLabelTranslation();

    return { translateLabel };
  },
});
</script>
